module.exports = __webpack_public_path__ + "img/8.41ff0a90.png";